import React from 'react';
import SectionHeading from './SectionHeading';
import useReveal from '../../hooks/useReveal';

const steps = [
  ['01', 'Задача', 'Укажите город, технику, дату и условия работы.'],
  ['02', 'Подбор', 'Получите подходящих исполнителей и сравните варианты.'],
  ['03', 'Работа', 'Подтвердите заказ и отслеживайте его статус в профиле.'],
];

const HowItWorks = () => {
  const ref = useReveal();
  return (
    <section className="border-y border-border-subtle bg-surface-1 py-20 md:py-28" aria-labelledby="how-heading">
      <div ref={ref} className="container-app">
        <div className="flex flex-col justify-between gap-5 md:flex-row md:items-end">
          <SectionHeading
            className="reveal"
            eyebrow="Сценарий"
            id="how-heading"
            title="От заявки до работы — три шага."
          />
          <p className="reveal reveal-delay-1 max-w-md text-sm leading-6 text-text-tertiary">
            Интерфейс построен вокруг следующего действия, поэтому вам не приходится искать нужную кнопку.
          </p>
        </div>
        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {steps.map(([num, title, text], i) => (
            <article key={num} className={`reveal reveal-delay-${i + 1} relative border-t border-border-default pt-5`}>
              {i < 2 && <span className="absolute right-0 -top-px hidden h-px w-10 bg-accent md:block" aria-hidden="true" />}
              <div className="font-mono text-xs text-accent">{num}</div>
              <h3 className="mt-8 text-xl font-semibold text-text-primary">{title}</h3>
              <p className="mt-2 max-w-sm text-sm leading-6 text-text-tertiary">{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
